import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(1).addClass("active");
$(".nei-nav ul li").eq(1).addClass("active");
var swiper = new Swiper(".swiper1", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 80,
    centeredSlides: false,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 40,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 80,
        }
    },
    navigation: {
      nextEl: ".btn1 .swiper-button-next",
      prevEl: ".btn1 .swiper-button-prev",
    },
});
var swiper = new Swiper(".swiper2", {
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 80,
  centeredSlides: false,
  grabCursor: true,
  keyboard: {
    enabled: true,
  },
  breakpoints: {
      320: { //当屏幕宽度大于等于320
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      },
      768: { //当屏幕宽度大于等于768 
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 40,
      },
      1280: { //当屏幕宽度大于等于1280
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 80,
      }
  },
  navigation: {
    nextEl: ".btn2 .swiper-button-next",
    prevEl: ".btn2 .swiper-button-prev",
  },
});
var swiper = new Swiper(".swiper3", {
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 80,
  centeredSlides: false,
  grabCursor: true,
  keyboard: {
    enabled: true,
  },
  breakpoints: {
      320: { //当屏幕宽度大于等于320
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      },
      768: { //当屏幕宽度大于等于768 
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 40,
      },
      1280: { //当屏幕宽度大于等于1280
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 80,
      }
  },
  navigation: {
    nextEl: ".btn3 .swiper-button-next",
    prevEl: ".btn3 .swiper-button-prev",
  },
});
var swiper = new Swiper(".swiper4", {
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 80,
  centeredSlides: false,
  grabCursor: true,
  keyboard: {
    enabled: true,
  },
  breakpoints: {
      320: { //当屏幕宽度大于等于320
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      },
      768: { //当屏幕宽度大于等于768 
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 40,
      },
      1280: { //当屏幕宽度大于等于1280
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 80,
      }
  },
  navigation: {
    nextEl: ".btn4 .swiper-button-next",
    prevEl: ".btn4 .swiper-button-prev",
  },
});
$(".swiper-list .swiper").eq(0).addClass('active');
$(".history .bottom ul li").eq(0).addClass("active");
$(".swiper-button-list .swiper-button").eq(0).addClass("active");
$(".history .bottom ul li").click(function() {
  let index = $(this).index();
  $(this).addClass('active').siblings().removeClass("active");
  $(".swiper-list .swiper").eq(index).addClass('active').siblings().removeClass("active");
  $(".swiper-button-list .swiper-button").eq(index).addClass('active').siblings().removeClass("active");
})